import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { GenericService } from 'app/_services/generic.service';
import { ClientSpecificInfoModel } from "app/support/models/client_specific_info.model";
import { environment } from "environments/environment";
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({
    providedIn: 'root',
})

export class ClientService extends GenericService<ClientSpecificInfoModel> {
    constructor(private http: HttpClient) {
        super(http,'/Client/', environment.Services.AlphaURLSlot2)
    }  
    
    getByDnisNumber(dnisNumber): Observable<any> {
        return this._http.post(this.url +"GetByDnisNumber",dnisNumber, this.prepareHeader()).pipe(map(res => res as any))
    }
}